export default __webpack_public_path__ + "static/media/Shadowy Bracers.76c81387.jpg";